import useApi from '../hook/useApi';

const usePreLeadsApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const refreshPreLead = async (status, page = 1) => {
    return sendRequest(`/imp/preleads_screen/get_all_prelead?status=${status}&page=${page}`, 'GET', {});
  };

  const updatePreLead = async (id, payload) => {
    //"accept", "schedule", "complete"
    return sendRequest(`/imp/preleads_screen/update_prelead/${id}`, 'PUT', payload);
  };

  const addTicket = async (payload) => {
    //"accept", "schedule", "complete"
    return sendRequest(`/imp/tickets_screen/add_ticket`, 'POST', payload);
  };

  const assignPreleads = async (payload) => {
    return sendRequest(`/imp/preleads_screen/dynamically_assign_preleads`, 'PATCH', payload);
  };

  return {
    refreshPreLead,
    updatePreLead,
    addTicket,
    assignPreleads,
    loading,
    data,
    error,
  };
};

export default usePreLeadsApi;